<template>
  <base-modal :id="modalId"
              class=""
              tabindex="-1"
              size="sm"
              centered
              hide-footer
              hide-header
              no-close-on-backdrop
              no-close-on-esc>
    <b-row align="center">
      <b-col>
        <h2 class="text-heading text-24 text-400"
            v-html="header">
        </h2>
      </b-col>
    </b-row>

    <div class="line-horizontal spacing-0"></div>

    <b-row class="spacing-3">
      <b-col>
        <span v-html="message"></span>
      </b-col>
    </b-row>

    <b-row class="spacing-4">
      <b-col>
        <button id="closeMessageButton"
                class="btn button--primary"
                type="button"
                @click="closeModal">
          {{ $t('global.close') }}
        </button>
      </b-col>
    </b-row>
  </base-modal>
</template>

<script>
// Components
import BaseModal from './BaseModal.vue'

// Libraries
import { mapState } from 'vuex'

// Utilities
import isEmpty from '../../../utility/isEmpty'
import Logger from '../../../utility/loggerUtil'

export default {
  name: 'broadcast-message-modal',

  components: {
    BaseModal
  },

  data () {
    return {
      modalId: 'broadcast-message-modal'
    }
  },

  computed: {
    header () {
      return !isEmpty(this.broadcastMessage) ? this.broadcastMessage.header : ''
    },

    message () {
      return !isEmpty(this.broadcastMessage) ? this.broadcastMessage.message : ''
    },

    pageNames () {
      return !isEmpty(this.broadcastMessage) ? this.broadcastMessage.pageNames : []
    },

    ...mapState('session', ['broadcastMessage'])
  },

  watch: {
    '$route' (to, from) {
      try {
        const cleanedName = !isEmpty(to.name) && to.name.includes('-') ? to.name.split('-')[1] : !isEmpty(to.name) ? to.name : ''
        if (!isEmpty(this.pageNames) && !isEmpty(cleanedName) && this.pageNames.includes(cleanedName)) {
          this.$bvModal.show(this.modalId)
        }
      } catch (e) {
        Logger.error('Error checking to show broadcast message modal')
        Logger.debug(e)
      }
    }
  },

  methods: {
    closeModal () {
      this.$bvModal.hide(this.modalId)
    }
  }
}
</script>
